module.exports = __webpack_public_path__ + "img/print02.0bd17e59.png";